import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { LabelMode } from "src/utils/label-mode.enum";
import { GenerateRandom } from "src/utils/random";

@Component({
  selector: "app-checkbox",
  templateUrl: "./checkbox.component.html",
  styleUrls: ["./checkbox.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent implements OnInit, ControlValueAccessor {
  @Input()
  set isDisabled(value: boolean) {
    if (value) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }

  @Input() set value(value: boolean) {
    this.form.setValue(value);
  }

  @Input() name = GenerateRandom(6);
  @Input() label: string;
  @Input() inputLabel: string;
  @Input() classes: string;
  @Input() InputClass: string;
  @Input() required: boolean = false;

  @Input() set labelMode(value: LabelMode) {
    this.mode = value;
  }

  @Output() valueChange = new EventEmitter();
  @Output() inputChange = new EventEmitter();

  LabelMode = LabelMode;
  mode: LabelMode = LabelMode.DEFAULT;

  form = new FormControl();

  onChange = (value: string) => {};
  onTouched = (value: string) => {};

  constructor() {}

  ngOnInit(): void {
    this.form.valueChanges.subscribe((value) => {
      this.valueChange.emit(value);
      this.onChange(value);
    });
  }

  writeValue(obj: any): void {
    this.form.setValue(obj);
  }
  onInputChange(value: Event) {
    const checkEvent = value.target as HTMLInputElement;

    this.inputChange.emit(checkEvent.checked);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {}
}
